module.exports = __webpack_public_path__ + "static/media/hands_12.c0665618.svg";